import scrollama from 'scrollama';
import { ai2htmlResize } from './utils/ai2html-resizer';
import { findElementByIdInShadowDom } from './utils/render.js';

const scrollContainer = findElementByIdInShadowDom('scroll-container');

const stepConfig = [
  // step 0: 1811 map
  {
    label: '1811',
    id: 'g-multiples-1811-box',
  },
  // step 1:  1812
  {
    label: '1812',
    id: 'g-multiples-1812-box',
  },
  // step 2: 1856
  {
    label: '1856',
    id: 'g-multiples-1856-box',
  },
  // step 3: 1857
  {
    label: '1857',
    id: 'g-multiples-1857-box',
  },
];

const mapYearLabel = findElementByIdInShadowDom('map-year-label');

let isInitialized = false;
const maps = [];

// Maps will be a list of objects that look like so:
// maps[step] = {
//   map: null,
// };

function initMaps() {
  if (isInitialized) return;

  // Run shadow-DOM lookups now that the component is mounted

  stepConfig.forEach((config, step) => {
    const map = {
      map: findElementByIdInShadowDom(config.id),
      label: config.label,
    };
    maps[step] = map;
  });

  isInitialized = true;
}

function hideAllMaps() {
  // Toggle everything off
  maps.forEach((map, step) => {
    toggleMap(step, false);
  });
}

function toggleMap(step, visible) {
  const { map } = maps[step];

  if (step === 0) {
    // 1811 (step 0) is visible by default via CSS, with no dependency
    // on JS — that's the fallback if the scroller script fails to load.
    // So instead of a class that makes it visible, it needs a class
    // that hides it once we've scrolled past it (and removes that
    // class again if the reader scrolls back up to step 0).
    map.classList.toggle('hide-map', !visible);
  } else {
    map.classList.toggle('show-map', visible);
  }
}

function handleStep({ index }) {
  initMaps();
  hideAllMaps();

  toggleMap(index, true);

  mapYearLabel.innerHTML = maps[index].label;
}

window.onload = function () {
  const scroller = scrollama();
  scroller
    .setup({
      step: '.step',
      offset: 0.5,
      debug: false,
      parent: scrollContainer,
    })
    .onStepEnter(handleStep);
  // .onStepExit(handleStep);
  window.addEventListener('resize', scroller.resize());
};
